/**
*
* Blocks
*
*/

import styled, { css } from 'styled-components';
import media from '../../style/mediainjector';

export const Div = styled.div`
  display: ${({ display }) => display};
  position: ${({ position }) => position};
  width: ${({ width }) => width};
  max-width: ${({ maxWidth }) => maxWidth};
  height: ${({ height }) => height};
  color: ${({ color }) => color};
  text-align: ${({ align }) => align};
  float: ${({ float }) => float};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  border: ${({ border }) => border};
  border-width: ${({ borderwidth }) => borderwidth};
  border-style: ${({ borderstyle }) => borderstyle};
  border-color: ${({ bordercolor }) => bordercolor};
  background-color: ${({ bgcolor }) => bgcolor};
  border-radius: ${({ radius }) => radius};
  overflow: ${({ overflow }) => overflow};
  user-select: ${({ userSelect }) => userSelect};
  pointer-events: ${({ pointerEvents }) => pointerEvents};
  z-index: ${({ zindex }) => zindex};
`;

const maxWidthValue = '960px';

export const ContainerStyle = css`
  position: relative;
  width: 100%;
  margin: ${({ margin }) => (margin || '0 auto')};
  max-width: ${({ maxWidth }) => (maxWidth || maxWidthValue)};
`;

export const Container = styled(Div)`
  ${ContainerStyle}
`;

export const FlexBox = styled(Div)`
  display: flex;
  flex-direction: ${({ direction }) => direction};
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};
  align-items: ${({ alignItems }) => alignItems || 'center'};
  align-content: ${({ alignContent }) => alignContent || 'center'};
  flex-wrap: ${({ wrap }) => (wrap || 'nowrap')};
`;

export const ContainerFlex = styled(FlexBox)`
  ${ContainerStyle}
`;

export const FlexChild = styled(FlexBox)`
  order: ${({ order }) => order};
  flex-grow: ${({ flexGrow }) => flexGrow};
  flex-basis: ${({ flexBasis }) => flexBasis};
  align-self: ${({ alignSelf }) => alignSelf};
`;

export const Section = styled.section`
  background-color: ${({ bgColor }) => (bgColor || 'transparent')};
  width: 100%;
  height: ${({ height }) => (height || 'auto')};
  display: flex;
  justify-content: ${({ justify }) => (justify || 'center')};
  align-items: center;
  flex-direction: ${({ direction }) => (direction || 'row')};
  position: relative;
  padding: ${({ padding }) => (padding || '50px')};
  ${({ paddingmobile }) => {
    const padding = `padding: ${paddingmobile || '30px 20px'};`;
    return media.lt667([padding]);
  }}
  ${({ full }) => full && css`
    height: 100%;
    flex-direction: ${({ direction }) => (direction || 'column')};
    ${({ flextop }) => flextop && css`
      justify-content: space-between;
      &:before {
        content: '';
        display: block;
      }
    `};
    ${({ flexbottom }) => flexbottom && css`
      justify-content: space-between;
      &:after {
        content: '';
        display: block;
      }
    `};
  `};
  ${({ first }) => first && css`
    padding-top: 136px;
    ${media.lt667`
      padding-top: 76px;
    `}
    ${media.print`
      padding-top: 36px !important;
    `}
    `};
  ${({ list }) => list && css`
    padding: 3.2rem 0 0;
    &:last-of-type {
      padding-bottom: 6.4rem
    }
    ${media.gt667`
      &:nth-child(2) {
        padding-top: 6.4rem
      }
    `}
    ${media.lt667`
      padding: 3.2rem 1.6rem 0;
      `}
    `};
`;

export const ActionBox = styled(Div)`
  ${ContainerStyle}
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  background-image: url(${({ bgImg }) => bgImg});
  ${({
    bgImg, bgSize, bgPosition, bgRepeat,
  }) => bgImg && css`
    background-size: ${bgSize};
    background-position: ${bgPosition};
    background-repeat: ${bgRepeat || 'no-repeat'};
  `}
  padding-bottom: ${(props) => props.paddingBottom || '60px'};
  ${media.mobile`
    padding-left: 40px;
    padding-right: 40px;
  `}
  ${media.lt667`
    flex-direction: column;
    background-position: ${({ bgPositionMobile, bgPosition }) => (bgPositionMobile || bgPosition)};
    background-size: ${({ bgSizeMobile, bgSize }) => (bgSizeMobile || bgSize)};
    max-height:740px;
    padding-left: 40px;
    padding-right: 40px;
  `}
  ${media.lt480`
    padding-left: 20px;
    padding-right: 20px;
  `}
`;

export const ActionVideoBox = styled.div`
  max-width: 50%;
  min-height: 290px;
  ${media.lt667`
    max-width: 80%;
    margin: -18px auto 0;
  `}
`;

export const PayOff = styled.h2`
  color: ${({ theme, color }) => (color || theme.brand)};
  font-size: 4.2rem;
  line-height: 45px;
  margin: 0 auto 24px;
  width: ${({ width }) => (width || 'auto')};
  ${media.lt667`
    margin: 0;
    font-size: 3.8rem;
    line-height: 1em;
  `}
`;

export const PayOffBox = styled.div`
  margin:0 40px 0 0;
  align-self: baseline;
  ${media.gt667`
    max-width: ${({ fullWidth }) => !fullWidth && '460px'};
  `}
  ${media.lt667`
    margin: 10px 0 30px 0;
    order: ${(props) => props.order};
  `}
`;

export const Warning = styled.div`
  color:  ${(props) => (props.color)};
  padding: 20px 26px;
  background: ${(props) => props.bgColor || '#FFFFFF'};
  border-radius: 9px;
  strong {
    color:  ${(props) => (props.strongColor)};
  }
  ul,
  p {
    margin: 0;
  }
  ul {
    padding-left: 20px;
  }
`;

export const Divider = styled.div`
  height: 2px;
  background: ${({ theme, color }) => (color || theme.brand)};
  margin: 80px auto;
  max-width: ${maxWidthValue};
  ${media.lt667`
    margin: 40px 20px;
  `}
`;

export const Video = styled.video`
  display: block;
  max-width: 100%;
  ${({ border }) => border && css`
    border: 1px solid ${({ theme }) => (theme.brand)};
  `}
  ${media.lt667`
    margin: 0 auto 30px;
  `}
`;

export const Image = styled.img`
  display: block;
  max-width: 100%;
  ${({ border }) => border && css`
    border: 1px solid ${({ theme }) => (theme.brand)};
  `}
  ${media.lt667`
    margin: 0 auto 30px;
  `}
`;
